import { Injectable } from '@angular/core';
import { HttpUtilityService } from './http-utility.service';
import { map, Observable, of } from 'rxjs';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { apiEndpoints } from '../constants/api-endpoints';
import {
  ContractorAPIData,
  ExportXLSData,
  ReportStatusAPIData,
} from '../interface/export-reports';
import { MXReport, RootObject } from '../interface/mx-reports';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  contractorData: ContractorAPIData | null = null;

  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  public getReportStatusList(): Observable<ReportStatusAPIData[]> {
    const url = apiEndpoints.reportStatusList;
    return this.httpUtilityService
      .get<HttpResponse<ReportStatusAPIData[]>>(url, {
        observe: 'response',
      })
      .pipe(
        map((response: HttpResponse<ReportStatusAPIData[]>) => {
          return response.body || [];
        })
      );
  }

  exportXLSData(data: ExportXLSData): Observable<HttpResponse<any>> {
    const url = apiEndpoints.exportXLSReport;
    return this.httpUtilityService.post(url, data, {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    });
  }

  getMXReports(data: MXReport): Observable<RootObject | null> {
    const url = apiEndpoints.varianceReport;
    return this.httpUtilityService
      .post<HttpResponse<RootObject>>(url, data, {
        observe: 'response',
      })
      .pipe(
        map((response: HttpResponse<RootObject>) => {
          return response.body || null;
        })
      );
  }

  public getContractor(): Observable<ContractorAPIData | null> {
    if (this.contractorData) {
      return of(this.contractorData);
    } else {
      const url = apiEndpoints.getContractor;
      return this.httpUtilityService
        .get<HttpResponse<ContractorAPIData>>(url, {
          observe: 'response',
        })
        .pipe(
          map((x: HttpResponse<ContractorAPIData | null>) => {
            this.contractorData = x.body || null;
            return this.contractorData;
          })
        );
    }
  }
}
